import React from 'react'

const RelatedProductCategory = ({ updateSelectedRelatedProductType, productTypeName, imageName, isSelected }) => {
  const imageUrl = `/globalassets/brandandcategoryimages/${imageName}.jpg`;

  return (
    <div key={productTypeName} className='col-xs-6 col-sm-4 col-md-2'>
      <a 
        role="button" 
        className={`related-item-type ${isSelected ? 'selected' : ''}`}
        onClick={() => !isSelected && updateSelectedRelatedProductType(productTypeName)}
      >
        <img src={imageUrl} alt={productTypeName} />
        <span className='related-item-type-caption'>
          <div className='inner'>{productTypeName}</div>
        </span>
      </a>
    </div>
  );
}

export default RelatedProductCategory